import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'components/Shared/Card';

interface IdentificationNPIProps {
    ABN?: string
}

export const IdentificationABN : FC<IdentificationNPIProps> = (props) => {
    const { ABN } = props;
    
    const { t, ready: translationsReady } = useTranslation('providerprofile', { useSuspense: false });

    const labels = {
        sectionHeader: t('identification_abn__section_title'),
        sectionDescription: t('identification_abn__section_description'),
        inputLabel: t('identification_abn__input_label'),
        noData: t('identification_abn__no_data')
    }

    return !translationsReady
        ? <></>
        : (
            <Card elevation={1} radius='regular' className="provider_profile_section_container">
                <div className="provider_profile_section_header">
                    <h2>{labels.sectionHeader}</h2>
                </div>
                {
                    ABN
                    ? <>
                        <p>{labels.sectionDescription}</p>
                        <p className='global__paragraph'>{ABN}</p>
                        <p className='global__paragraph global__paragraph--small'>{labels.inputLabel}</p>
                    </>
                    : <p>{labels.noData}</p>
                }
            </Card>
        )
}